<div class="section__header wx-section__header">
  <h2 class="section__header-text wx-section__header-text">TAFs
    <button (click)="openWeatherLegend()">
      <mat-icon
        style="height:24px !important; width:24px !important; font-size:24px !important; vertical-align: bottom;"
        aria-label="Weather Legend">help_outline</mat-icon>
    </button>
  </h2>
  <div class="section__header-actions wx-section__header-actions">
    <mat-slide-toggle [(ngModel)]="translated">Translated</mat-slide-toggle>
  </div>
</div>
<div class="section__body wx-section__body">
  <app-state-view [promise]="tafPromise">
    <loading-state [template]="loading"></loading-state>
    <empty-state [template]="placeholder"></empty-state>
    <error-state [template]="error"></error-state>
    <content-state>
      <div *ngIf="primaryTaf" class="section__subsection wx-section__subsection">
        <h3 class="section__subsection-header section__subsection-header-text">TAFs from this airport:</h3>
        <div class="section__subsection-body wx-section__subsection-body" [class.wx-section__subsection-body--raw]="!translated">
          <app-taf [taf]="primaryTaf" [translated]="translated"></app-taf>
        </div>
      </div>
      <div class="section__subsection wx-section__subsection">
        <h3 class="section__subsection-header section__subsection-header-text">TAFs from nearby airports:</h3>
        <div *ngIf="nearbyTafs && nearbyTafs.length; else placeholder"
             class="section__subsection-body wx-section__subsection-body"
             [class.wx-section__subsection-body--raw]="!translated">
          <div class="wx-section__nearby-wx">
            <app-taf *ngFor="let taf of nearbyTafs" [taf]="taf" [referencePoint]="latlon" [translated]="translated"></app-taf>
          </div>
        </div>
      </div>
    </content-state>
  </app-state-view>
</div>
<ng-template #loading>
  <div class="wx-section__placeholder">
    <mat-spinner [diameter]="16" class="wx-section__spinner"></mat-spinner>
  </div>
</ng-template>
<ng-template #error>
  <div class="wx-section__placeholder wx-section__placeholder--error">
    <mat-icon class="wx-section__placeholder-icon">warning</mat-icon>
    <div class="wx-section__placeholder-message">An error occurred loading TAF information. Please try again later.</div>
  </div>
</ng-template>
<ng-template #placeholder>
  <div class="wx-section__placeholder">
    <mat-icon class="wx-section__placeholder-icon">info</mat-icon>
    <div class="wx-section__placeholder-message">No TAF reporting stations were found near {{identifier.toUpperCase().startsWith('ZZ') ? 'this airport' : identifier}}.</div>
  </div>
</ng-template>
